export const hw_completed_mix = {
  methods: {
    returnCompletedHW(train, student_id){
      let items = _.filter(train, (i)=>{
        return i.student_id == student_id;
      });

      if (this.completedByFact(items).length === 0) {
        //console.log('Выполнено!');
        let result = this.checkByQuality(items);
        return result;
      } else {
        return 0;
      }
    },

    checkCompletedHW() {
      if (this.completedByFact(this.train).length === 0) {
        //console.log('Выполнено!');
        let result = this.checkByQuality(this.train);
        this.status = `Выполнено на ${result}%`;
      } else {
        this.status = 'Не выполнено';
      }
    },
    completedByFact(items) {
      //console.log(items);
      let ret = _.filter(items, function (e) {
        return e.homework.trainer && e.is_done == 0;
      });
      return ret;
    },
    checkByQuality(items) {
      //console.log('Check by qual');
      let completed = _.filter(items, function (e) {
        return e.is_done == 1;
      });

      let result = [];
      let n = 0;
      _.forEach(completed, (comp) => {
        //console.log(comp);
        _.forEach(comp.statistic, (i)=>{
          let perc;
          switch (i.trainer_id) {
            case 4:
              perc = this.checkMnemoStat(i);
              break;
            case 3:
            case 5:
            case 6:
            case 8:
              perc = this.checkMentalStat(i);
              break;
            case 1:
            case 2:
              perc = this.checkTableStat(i);
              break;
          }
          result.push(perc);
          n++;
        });
      });
      let final_result = Math.round((_.sum(result) / (n > 0 ? n : 1)));
      //console.log('Result', result, final_result);
      return final_result;
    },
    checkMnemoStat(item){
      return (100 - Math.round((item.errors / (item.params['size'] * item.params['size'])) * 100));
    },
    checkMentalStat(item){
      return this.perc(item.errors, (item.count ? item.count : 1));
    },
    checkTableStat(item){
      if (item.errors >= 10) {
        return 0;
      } else if (item.errors == 0) {
        return 100;
      } else if (item.errors < 3) {
        return item.errors == 1 ? 90 : 80;
      } else {
        return 70;
      }
    },
    perc(n1, n2){
      return (100 - Math.round(((n1 / n2) * 100)));
    }
  }
}